<script>
import AppointmentRequest from './appointment-request.vue'
export default {
  components: { AppointmentRequest },
  props: {
    contactId: {type: String, required: true},
  },

  data() {
    return {
      observed: this.$storage.observed,
      mmUserId: this.$storage.get('mm_user_id'),
      directChannel: this.$storage.getDirectChannel(this.contactId),
      displayAppRequestForm: false,
    }
  },

  watch: {
    'observed.directChannels': function (newVal, oldVal) {
      let me = this
      setTimeout(function() {
        me.directChannel = me.$storage.getDirectChannel(me.contactId)
      }, 500);
    }
  },

  methods: {
    routeToPrivateChannel(channel, params={}) {
      this.$router.push({path: `/community/${this.contactId}/${channel.id}`, query: params})
    },

    onPrivateMessage(data) {
      if (!this.directChannel) {
        let me = this
        let uids = [this.mmUserId, this.contactId]
        this.$mattermost.post(`/channels/direct`, uids).then(function(response) {
          console.log('created channel: ', response)
          me.directChannel = response.data
          me.routeToPrivateChannel(me.directChannel, data)
        })
      } else
        this.routeToPrivateChannel(this.directChannel, data)
    },

    onAppointmentRequest(appointmentInfo) {
      this.displayAppRequestForm = false
      let i = appointmentInfo
      let message = `:calendar: Bitte um Termin am: **${i.date}**\n**${i.time} Uhr** zum Thema: **${i.subject}**`
      this.onPrivateMessage({message:message})
    }
  },
}
</script>

<template>
  <div>
    <button @click.prevent="onPrivateMessage" class="btn btn-secondary">
      Nachrichten&nbsp;<span v-if="directChannel && directChannel.numUnreadMessages" class="badge bg-danger">{{ directChannel.numUnreadMessages }}</span>
    </button>
    <button @click.prevent="displayAppRequestForm = !displayAppRequestForm" 
     class="btn btn-secondary ms-1">
      Termin-Anfrage
    </button>
    <appointment-request v-if="displayAppRequestForm"
     @submit="onAppointmentRequest($event)"
     class="mt-3"
    />
  </div>
</template>
